export interface IHasTotalPriceByTravellerOrAccomodationId {
    getTotalPriceByTravellerOrAccomodationId(id: string): number
    setTotalPriceByTravellerOrAccomodationId(id: string, price: number): void
}

function hasTotalPriceByTravellerOrAccomodationId<TBase extends Constructor>(Base: TBase) {
    return class extends Base implements IHasTotalPriceByTravellerOrAccomodationId {
        private totalPriceByTravellerOrAccomodationId: {[id: string]: number} = {}

        constructor(...args: any[]) {
            super(...args);
        }

        public getTotalPriceByTravellerOrAccomodationId(id: string): number {
            return this.totalPriceByTravellerOrAccomodationId ? this.totalPriceByTravellerOrAccomodationId[id] : 0
        }
        public setTotalPriceByTravellerOrAccomodationId(id: string, price: number): void {
            this.totalPriceByTravellerOrAccomodationId[id] = price
        }
    };
}

export default hasTotalPriceByTravellerOrAccomodationId